import { render } from "./ModalAddPaymentProof.vue?vue&type=template&id=fbab50d0&scoped=true"
import script from "./ModalAddPaymentProof.vue?vue&type=script&lang=js"
export * from "./ModalAddPaymentProof.vue?vue&type=script&lang=js"

import "./ModalAddPaymentProof.vue?vue&type=style&index=0&id=fbab50d0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbab50d0"]])

export default __exports__